import type { BoxProps } from "@mantine/core";
import { Box } from "@mantine/core";
import { useId, type FC } from "react";

type Props = BoxProps & {
  color?: string;
  animated?: boolean;
};

export const NullIcon: FC<Props> = ({
  color = "var(--mantine-color-text)",
  animated = false,
  ...props
}) => {
  const fill = color;
  const uid = useId().replace(/:/g, "");

  const fadeClass = `ni-fade-${uid}`;
  const fadeDelayClass = `ni-fade-delay-${uid}`;

  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 297 236"
        style={{ width: "100%" }}
      >
        {animated && (
          <style>{`
            @keyframes ${fadeClass}-kf {
              from { opacity: 0; }
              to   { opacity: 1; }
            }
            .${fadeClass} {
              opacity: 0;
              animation: ${fadeClass}-kf 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
            }
            .${fadeDelayClass} {
              opacity: 0;
              animation: ${fadeClass}-kf 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.15s forwards;
            }
          `}</style>
        )}
        <g>
          <path
            d="M130.380005,46.089996 C155.730005,46.269996,170.790005,66.819996,164.040005,92.189995 L164.010005,92.189995 L148.370004,150.949993 C145.050004,163.439993,152.500005,173.569994,165.020004,173.569994 L187.580003,173.569994 L209.240003,92.189997 C222.510004,42.329996,193.150003,1.879999,143.590002,1.049997 L143.610002,0.969997 L63.169999,0.969997 L51.159999,46.069996 L51.159999,46.069996 L51.159999,46.069996 L0.619998,235.969990 L23.239999,235.969990 C35.729999,235.969990,48.539998,225.869989,51.860000,213.409990 L96.389999,46.089983 L130.380005,46.089996 Z "
            fill={fill}
            {...(animated && { className: fadeClass })}
          />
          <path
            d="M245.529999,190.889999 L245.529999,190.869999 L296.070000,0.970005 L273.449999,0.970005 C260.959999,0.970005,248.150000,11.070006,244.829998,23.530005 L200.299999,190.850012 L166.309998,190.850012 C140.959997,190.670012,125.899998,170.120013,132.649998,144.750014 L132.679998,144.750014 L148.319998,85.990015 C151.639998,73.500016,144.189998,63.370015,131.669998,63.370015 L109.109999,63.370015 L87.449999,144.750012 L87.449999,144.750012 C74.179999,194.610013,103.539999,235.060009,153.110003,235.890011 L153.090003,235.970011 L233.530005,235.970011 L245.530005,190.890009 C245.530005,190.890009,245.540005,190.880009,245.540005,190.870009 L245.540005,190.890009 L245.529999,190.889999 Z "
            fill={fill}
            {...(animated && { className: fadeDelayClass })}
          />
        </g>
      </svg>
    </Box>
  );
};
